import React from 'react'

export default function Address() {
    return (
        <a href="https://goo.gl/maps/BtkGsQoTwcnCsjgG6">
            <table>
                <tbody>

                <tr>
                    <td>
                        5504 E Burnside St.
                    </td>
                </tr>
                <tr>
                    <td>
                        Portland, OR 97215
                    </td>
                </tr>
                </tbody>
            </table>
        </a>
    )
}
